<template>
<v-layout fluid style="width: 100%;" class="pa-0 d-flex flex-row" fill-height wrap lights-out>
    <v-col cols="12" sm="12" lg="3"  :style="{'background-color': color}">
        <v-row class="ma-0">
			<v-col cols="auto" class="pa-0">
				<slot name="breadcrumbs" :item="true"></slot>
			</v-col>
            <v-spacer/>
            <!-- export -->
			<v-col cols="auto" class="pa-0">
				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn dark color="printingColor" class="px-2" v-on="on">
							<span class="d-flex align-center">
								<v-icon color="white">mdi-export-variant</v-icon>
								<span style="font-size: 14px">
									{{$t('MaterialsTreePage.export')}}
								</span>
							</span>
						</v-btn>
					</template>

					<bee-list>
						<!-- excel -->
						<bee-list-item
							context="tree"
							:item="exportItems[0]"
							dense
							@click="exportAs('excel')"
						></bee-list-item>

						<!-- pdf -->
						<bee-list-item
							context="tree"
							:item="exportItems[1]"
							dense
							@click="exportAs('pdf')"
						></bee-list-item>
					</bee-list>
				</v-menu>
			</v-col>
        </v-row>
        <v-row>
            <v-col cols="auto" lg="12" md="12" sm="12" xs="12" class="pt-0">
                <bee-autocomplete 
                item-text="name"
                item-value="id"
				:label="$t('MaterialsTreePage.warehouse')"
				:items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? warehousesForKeeper : warehouses"
				v-model="warehouse"
				:clearable="false"
                :hide-details="true"
                context="warehouse"
                :action-name="actions.GET"
			></bee-autocomplete>
            </v-col>
        </v-row>
        <v-row fill-height>
			<v-main style="width: 100%" class="px-3 pt-0" color="greyLighten5">
				<bee-treeview
				    v-if="renderComponent"
				    @update:active="Update($event)"
				    :filter-hint="$t('MaterialsTreePage.material-name-or-no')"
				    :lables-values="['inner_no', 'name']"
				    :items="materials_tree"
				>
                    <template v-slot:actions="{}">
                        <bee-btn
                        @click="create()"
                        :disabled="file_is_locked"
                        color="addingColor"
                        context="material"
                        :action-name="actions.CREATE">
                            <template v-slot:content="" >
                                <v-img width="25" contain :src="require('../../../assets/add-product.png')" class="mx-1"></v-img>
                                {{$t('MaterialsTreePage.add')}}
                            </template>
                        </bee-btn>
                    </template>
                </bee-treeview>
			</v-main>
        </v-row>
    </v-col>

    <v-col cols="auto" sm="12" lg="9">
		<v-scroll-y-transition mode="out-in">
			<v-card flat style="height: 80vh" v-if="!selected" class="d-flex flex-column justify-content-center justify-center">
			<v-card-text>
			<v-img
					left
					class="shrink"
					contain
					:src="require('../../../assets/choose-material.png')"
					transition="scale-transition"
					height="200"
				/>
			</v-card-text>
			<v-card-title class="align-center justify-center">
				<span style="align-self: center;" class="blue-grey--text text--lighten-1 font-weight-light">
                    {{$t('MaterialsTreePage.please-select-material')}}
                </span>
			</v-card-title> 
			</v-card>
			
			<router-view v-else></router-view>
		</v-scroll-y-transition>
	</v-col>
</v-layout>
</template>
<script>
import { mapState } from "vuex";
import  store  from "../../../store/index.js";
import EventBus from '../../../event-bus';
import actions from "../../../permissions/actions-names.js"
import ls from '../../../settings/localStorageExtension';
import { userType } from '@/helpers/enums';
import { multipleWarehouses } from '@/configs/global'
export default {
data: () => ({
	actions,
	renderComponent:true,
    selected: false,
    node: {id: null},
	userType,
	multipleWarehouses
  }),
methods: {
	create() {
        this.node.id  && this.selected
			? this.$router.push({ name: "add-material", params: { parentId: this.node.id } }).catch(()=>{}) 
			: this.$router.push({ name: "create-material" }).catch(()=>{})
    },
    Update(item) {
        this.selected = true
		if(item)
		{
			this.$router.push({ name: "update-material", params: { id: item.id } }).catch(()=>{})
			this.node = item
		}
		else{
			this.$router.push({ name: "materials-tree"}).catch(()=>{})
            this.node = {id: null}
		}	
    },
	forceRerender(){

        Promise.all([store.dispatch('materials/fetchTree',  Number(this.$route.params.warehouseId)),
            store.dispatch('materials/fetchWarehouseMaterials', Number(this.$route.params.warehouseId))
        ])

        // Remove my-component from the DOM
        this.renderComponent = false;

        setTimeout(() => {
          // Add the component back in
          this.renderComponent = true;
        }, 2000);
    },
    
    exportAs(type) {
        this.$store.dispatch('reports/MaterialsTreeReport', {
            type,
            financialFileId: this.configs.financial_file.id,
			userId: ls.getLocalUser().id,
            warehouseId: Number(this.$route.params.warehouseId)
        })
    }
},
computed: {
    ...mapState("configs", ["configs"]),
	...mapState("materials" , ["materials_tree"]),
    ...mapState("warehouses" , ["warehouses"]),
	...mapState({
		userTypePermission: state => state.permissions.user_type,
		warehousesForKeeper: state => state.warehouses.warehousesForKeeper
	}),
    exportItems() {
		return [
			{
				text: this.$t('MaterialsTreePage.export-as-excel'),
				icon: 'mdi-microsoft-excel',
				context: 'tree',
				action_name: actions.EXPORT_AS_PDF
			},
			{
				text: this.$t('MaterialsTreePage.print-materials-tree'),
				icon: 'mdi-printer',
				context: 'tree',
				action_name: actions.EXPORT_AS_PDF
			},
		]
	},
    file_is_locked(){
        return this.configs?.financial_file?.is_locked },
    color() {
      return this.$vuetify.theme.themes.light.greyLighten5;
	},
    warehouse:{
        get: function(){
            return Number(this.$route.params.warehouseId)
        },
        set: function (value) {
            if(Number(value))
                this.$router.push({ name: "materials-tree", params: { warehouseId: value} })
                            .then(()=>this.forceRerender())
                            .catch(()=>{})
        }
    }
},
watch: {
	$route: function () {
		(this.$route.name == "materials-tree")  ? this.selected = false : this.selected = true
	}
},
mounted(){
    if(this.$route.params.warehouseId)
        this.forceRerender()

	EventBus.$on('reload-materials-tree', ()=>{ this.forceRerender()});
},
async beforeRouteEnter(to, from, next) {
    let promises = [store.dispatch('warehouses/fetchAll'), store.dispatch('unitSizes/fetchAll')]

    let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch('configs/fetchAll'))

	await Promise.all(promises)

    next(vm => {
		to.name == "materials-tree" ? vm.selected = false : vm.selected = true
    })
},
meta: {
		title: 'accounts-tree',
		meta: [
			{property: 'og:title', content: 'materials-tree / mirta'},
		],
	},
};
</script>
<style scoped>

</style>